import { LOAD_PROMOTIONS_PROMO_CODES_SUCCESS } from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_PROMOTIONS_PROMO_CODES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/promotions/PromotionPromoCodesReducer.js